import React, { useState, useEffect } from 'react';
import './Style/SignUp.css';
import { useNavigate } from 'react-router-dom';
import TopNavbar from '../home/TopNavbar';
import { API_CONFIG } from './../config'; 

const UPDATE_USER_API = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.UPDATEPROFILE}`;

const FETCH_USERS_API = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.USERDATA}`;

   
const UpdateProfile = () => {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [submissionStatus, setSubmissionStatus] = useState(null);

    const [formData, setFormData] = useState({
        name: '',
        class: '',
        email: localStorage.getItem('userEmail') || '',
        phone: localStorage.getItem('userPhone') || ''
    });

    useEffect(() => {
        if (!formData.email) {
            alert("Session expired. Please login again.");
            navigate('/login');
            return;
        }

        const fetchCurrentUserData = async () => {
            try {
                const response = await fetch(FETCH_USERS_API);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();

                if (result.success && result.data) {
                    const currentUser = result.data.find(user => user.email === formData.email);
                    if (currentUser) {
                        setFormData(prev => ({
                            ...prev,
                            name: currentUser.name || '',
                            class: currentUser.class || ''
                        }));
                    } else {
                        console.error("User not found in database records.");
                    }
                }
            } catch (error) {
                console.error("Error fetching user profile data:", error);
                alert("Failed to load profile data. Please try again.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchCurrentUserData();
    }, [formData.email, navigate]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setSubmissionStatus(null);
    };

    const handleUpdate = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.class) {
            alert("Please fill in all fields");
            return;
        }

        setIsSubmitting(true);
        setSubmissionStatus('processing');

        try {
            // Only send the fields that can be updated
            const updatePayload = {
                email: formData.email,
                name: formData.name,
                class: formData.class
            };

            const response = await fetch(UPDATE_USER_API, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatePayload),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success) {
                setSubmissionStatus('success');
                localStorage.setItem('userName', formData.name);
                localStorage.setItem('userClass', formData.class);

                setTimeout(() => {
                    navigate('/profile');
                }, 1500);
            } else {
                setSubmissionStatus('error');
                console.error("Update failed:", result.message);
                alert(result.message || "Update failed. Please try again.");
            }

        } catch (error) {
            console.error('Update error:', error);
            setSubmissionStatus('error');
            alert("Network error. Please check your connection and try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="signup-container">
            <div className="signup-card">
                <br />
                <h2>Update Profile</h2>
                <TopNavbar name="Update Profile" />

                <div className="form-wrapper">
                    {isLoading ? (
                        <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                            ⏳ Loading profile data...
                        </div>
                    ) : (
                        <form onSubmit={handleUpdate} className="signup-form">
                            {/* NAME FIELD */}
                            <div className="form-group">
                                <label htmlFor="name">Full Name</label>
                                <div className="input-wrapper">
                                    <span className="phone-icon">👤</span>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        placeholder="Enter your full name"
                                        maxLength="25"
                                        required
                                        disabled={isSubmitting}
                                    />
                                </div>
                            </div>

                            {/* CLASS FIELD */}
                            <div className="form-group">
                                <label htmlFor="class">Class</label>
                                <div className="input-wrapper">
                                    <span className="phone-icon">🎓</span>
                                    <select
                                        id="class"
                                        name="class"
                                        value={formData.class}
                                        onChange={handleInputChange}
                                        required
                                        disabled={isSubmitting}
                                        className="select-dropdown"
                                    >
                                        <option value="" disabled>Select your class</option>
                                        <option value="12 pass">Class 12 pass</option>
                                        <option value="12">Class 12</option>
                                        <option value="11">Class 11</option>
                                        <option value="below 11">Below of Class 11</option>
                                    </select>
                                </div>
                            </div>

                            {/* EMAIL FIELD (Locked) */}
                            <div className="form-group">
                                <label>Email Address (Locked)</label>
                                <div className="input-wrapper" style={{ opacity: 0.7 }}>
                                    <span className="phone-icon">✉️</span>
                                    <input
                                        type="email"
                                        value={formData.email}
                                        disabled
                                    />
                                </div>
                            </div>

                            {/* PHONE FIELD (Locked) */}
                            <div className="form-group">
                                <label>Phone (Locked)</label>
                                <div className="input-wrapper" style={{ opacity: 0.7 }}>
                                    <span className="phone-icon">📞</span>
                                    <input
                                        type="tel"
                                        value={formData.phone}
                                        disabled
                                    />
                                </div>
                            </div>

                            {/* SUBMIT BUTTON */}
                            <button 
                                type="submit" 
                                className="submit-btn" 
                                disabled={isSubmitting}
                                style={{
                                    width: '100%',
                                    padding: '12px',
                                    backgroundColor: isSubmitting ? '#ccc' : '#4CAF50',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    fontSize: '16px',
                                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                    marginTop: '20px'
                                }}
                            >
                                {isSubmitting ? 'Updating...' : 'Update Profile'}
                            </button>

                            {/* STATUS ALERTS */}
                            {submissionStatus === 'success' && (
                                <div className="status-message success" style={{ 
                                    background: '#e6f4ea', 
                                    color: '#137333', 
                                    padding: '12px', 
                                    marginTop: '10px', 
                                    borderRadius: '6px',
                                    textAlign: 'center'
                                }}>
                                    ✅ Profile updated successfully! Redirecting...
                                </div>
                            )}

                            {submissionStatus === 'error' && (
                                <div className="status-message error" style={{ 
                                    color: 'red', 
                                    textAlign: 'center', 
                                    marginTop: '10px' 
                                }}>
                                    ❌ Update failed. Please try again later.
                                </div>
                            )}

                            <br /><br /><br />
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UpdateProfile;